import Vue from 'vue';
import {
 getTags, getMemberList, storeTag, showTag, updateTag, destroyTag,
  getBackendTags, getBackendMemberList, showBackendTag, updateBackendTag
} from '../../../services/personnelService/labelService';

  // initial state
  // state 必為模組區域變數，取時需 store.state.auth.user
  // 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
  // 區域使用時值需加上 name
  const state = {
    tags: [],
    memberList: [],
    selectUsers: [],
    pagination: {
      current_page: 0,
      per_page: 5
    },
    noData: true
  };

  // getters
  const getters = {};

  // actions
  const actions = {
    //* *** 前台標籤 ****//
    // 取得前台標籤列表
    async getTagsHandler({ commit }, info) {
      const data = await getTags(info);
      commit('setTags', data.data);
    },
    // 取得可新增標籤的會員
    async getMemberListHandler({ commit }, paginationInfo) {
      const data = await getMemberList(paginationInfo);
      commit('setMemberList', data);
    },
    // 新增標籤
    async storeTagHandler({}, storeInfo) {
      await storeTag(storeInfo);
    },
    // 編輯標籤
    async showTagHandler({}, showInfo) {
      const { data } = await showTag(showInfo);
      return data;
    },
    // 更新標籤
    async updateTagHandler({}, updateInfo) {
      await updateTag(updateInfo);
    },
    // 刪除標籤
    async destroyTagHandler({}, tagInfo) {
      await destroyTag(tagInfo);
    },
    //* *** 後台標籤 ****//
    // 取得後台標籤列表
    async getBackendTagsHandler({ commit }, info) {
      const data = await getBackendTags(info);
      commit('setTags', data.data);
    },
    // 取得可新增標籤的會員
    async getBackendMemberListHandler({ commit }, paginationInfo) {
      const data = await getBackendMemberList(paginationInfo);
      commit('setMemberList', data);
    },
    // 編輯標籤
    async showBackendTagHandler({}, showInfo) {
      const { data } = await showBackendTag(showInfo);
      return data;
    },
    // 更新標籤
    async updateBackendTagHandler({}, updateInfo) {
      await updateBackendTag(updateInfo);
    }
  };

  // mutations
  const mutations = {
    setTags(state, data) {
      Vue.set(state, 'tags', data.tags);
      if (data.tags && data.tags.length > 0) {
        Vue.set(state, 'noData', false);
      } else {
        Vue.set(state, 'noData', true);
      }
    },
    setMemberList(state, data) {
      Vue.set(state, 'memberList', state.memberList.concat(data.data.members));
      Vue.set(state, 'pagination', data.pagination);
    },
    setSelectUsers(state, data) {
      Vue.set(state, 'selectUsers', data);
    },
    // 重置所有資料
    resetAll(state) {
      Vue.set(state, 'tags', []);
      Vue.set(state, 'memberList', []);
      Vue.set(state, 'selectUsers', []);
      Vue.set(state, 'pagination', {
        current_page: 0,
        per_page: 5
      });
      Vue.set(state, 'noData', false);
    },
    // 重置分頁
    resetInfiniteLoadingData(state) {
      Vue.set(state, 'memberList', []);
      Vue.set(state, 'pagination', {
        current_page: 0,
        per_page: 5
      });
    },
    // 移除某個選擇過的使用者
    removeSelectUsers(state, key) {
      state.selectUsers.splice(key, 1);
    }
  };

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
